import { OcapiError } from '../../../../types/ocapi-error';
import { getResponseErrorCode } from '../../../../utils/get-response-error-code';
export var PrepareAllItemDeliveriesErrorCodeV1;
(function (PrepareAllItemDeliveriesErrorCodeV1) {
    /**
     * The order does not contain any [[OrderItemDelivery]] entities that have an on request schedule.
     */
    PrepareAllItemDeliveriesErrorCodeV1[PrepareAllItemDeliveriesErrorCodeV1["UnsupportedDeliverySchedules"] = 16200] = "UnsupportedDeliverySchedules";
    /**
     * Preparation of all [[OrderItemDelivery]] entities has already been started.
     */
    PrepareAllItemDeliveriesErrorCodeV1[PrepareAllItemDeliveriesErrorCodeV1["AlreadyStarted"] = 16201] = "AlreadyStarted";
})(PrepareAllItemDeliveriesErrorCodeV1 || (PrepareAllItemDeliveriesErrorCodeV1 = {}));
export class PrepareAllItemDeliveriesErrorV1 extends OcapiError {
    constructor(errorCode) {
        const message = `Failed to prepare order item deliveries. API error code ${errorCode}: ${PrepareAllItemDeliveriesErrorCodeV1[errorCode]}`;
        super(errorCode, message);
    }
}
export async function getPrepareAllItemDeliveriesErrorV1(error) {
    const errorCode = await getResponseErrorCode(error);
    return errorCode && Object.values(PrepareAllItemDeliveriesErrorCodeV1).includes(errorCode)
        ? new PrepareAllItemDeliveriesErrorV1(errorCode)
        : error;
}
//# sourceMappingURL=prepare-all-item-deliveries-error.js.map